import React, {Component} from "react";
import {connect} from "react-redux";
import FullHistory from "./FullHistory";
import {loadHistory} from "./../actions/historyActions";
import ChangeHistory from "./ChangeHistory";
import LastDifferingRecommendation from "./LastDifferingRecommendation";
import Header from "./Header";
import Recommendation from "./Recommendation";
import Disclaimers from "./Disclaimers";
import { ERRORS } from "../actions/fetchDisclosureDataFromServer";

export const NotFound = (props) => (
    <div style={{textAlign: "center", paddingBottom: "1em"}}>
        <h3>The page you're looking for is not ready yet</h3>
        <div>Please try again in a few minutes</div>
    </div>
);

export const Forbidden = (props) => (
    <div style={{textAlign: "center", paddingBottom: "1em"}}>
        <h3>Sorry, these disclosures have not been sent to your email address</h3>
        <div>If you require any help please use the support button below</div>
    </div>
);

export class Disclosures extends Component {
    componentDidMount() {
        this.props.loadDisclosureFor(this.props.params.recommendationId);
    }

    render() {
        switch (this.props.fetchError) {
            case ERRORS.NOT_FOUND:
                return <NotFound/>;
            case ERRORS.FORBIDDEN:
                return <Forbidden/>;
            default:
                return this._renderDisclosures();
        }
    }

    _renderDisclosures() {
        const recommendations = this.props.history.recommendations;
        const recommendation = (recommendations.length) ? recommendations[0] : {};
        const lastDifferingRecommendation = this.props.lastDiffering;
        const firstDisseminatedOn = (this.props.changeHistory && this.props.changeHistory.length) > 0 ? this.props.changeHistory[this.props.changeHistory.length - 1].disseminatedOn : null;

        return <div>
            { this.props.author
                ? <Header firstName={this.props.author.firstName} lastName={this.props.author.lastName} email={this.props.author.email} companyName={this.props.author.companyName} regulatingAuthority={this.props.author.regulatingAuthority} jobRole={this.props.author.jobRole} />
                : <Header firstName={null} lastName={null} email={null} companyName={null} regulatingAuthority={null} jobRole={null} />
            }

            <Recommendation {...recommendation}
                            authorName={this.props.author ? this.props.author.firstName : null}
                            firstDisseminatedOn={firstDisseminatedOn} />

            { lastDifferingRecommendation && lastDifferingRecommendation.recommendation
                ? <LastDifferingRecommendation recommendation={ lastDifferingRecommendation.recommendation } />
                : undefined }

            <ChangeHistory history={this.props.changeHistory}
                           authorName={this.props.author ? this.props.author.firstName : null}
                           issuer={ recommendation.companyName } />

            <FullHistory history={this.props.history} authorName={this.props.author ? this.props.author.firstName : null}/>

            { recommendation && recommendation.disclaimers && recommendation.disclaimers.length !== 0 ? <Disclaimers disclaimers={recommendation.disclaimers} /> : undefined }
        </div>;
    }
}
Disclosures.propTypes = {
    fetchError: React.PropTypes.string,
    loadDisclosureFor: React.PropTypes.func.isRequired,
    history: React.PropTypes.shape({
        recommendations: React.PropTypes.array
    }),
    author: React.PropTypes.object,
    changeHistory: React.PropTypes.array,
    lastDiffering: React.PropTypes.shape({
        id: React.PropTypes.string,
        recommendation: React.PropTypes.object
    })
};

export const mapDispatchToProps = (dispatch, ownProps, loadHistoryThunk = loadHistory) => ({
    loadDisclosureFor: (recommendationId) => dispatch(loadHistoryThunk(recommendationId))
});

export const mapStateToProps = (state) => ({
    fetchError: state.disclosures.fetchError,
    history: state.disclosures.history,
    author: state.disclosures.author,
    changeHistory: state.disclosures.changeHistory,
    lastDiffering: state.disclosures.lastDiffering
});

export default connect(mapStateToProps, mapDispatchToProps)(Disclosures);



/** WEBPACK FOOTER **
 ** ./src/main/javascript/disclosure/components/Disclosures.js
 **/